/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Globals from "./Globals";
import { qreq } from "./qrequest";

class SharedUtilClass {
    downloadProgressReport(orderID, visitID) {
        if (!visitID) visitID = '0';
        let url = Globals.serverUrl + '/api/report/wound/status/pdf/' + orderID + '/' + visitID + '/progress-report-' + orderID + '.pdf?timezone=' + Globals.getTimeZoneForQuery();
        if (Globals.isIOS()) {
            url += '?downloadOnly=true';
            window.location.href = url;
        }
        else
            window.open(url);
    }

    async progressReportAvailableAsync(orderID, visitID) {
        if (!visitID) visitID = '0';
        return new Promise(async (resolve, reject) => {
            try {
                let j = await qreq.getAsync('/api/report/wound/status/available/' + orderID + '/' + visitID);

                if (j.errorCode === 0)
                    resolve(true);
                else
                    resolve(false);
            }
            catch (e) {
                console.error(e);
                reject('Unknown error.');
            }
        });
    }

    async getMainOrgAsync() {
        try {
            const j = await qreq.getAsync('/api/organization/main');
            if (j.item)
                return j.item;
            else if (j.errorCode === -101)
                return -101;
            else {
                return null;
            }
        }
        catch (ex) {
            console.error('An unkown error ocurred. Login service might be down. Please try again later.');
            return null;
        }
    }
}

const SharedUtil = new SharedUtilClass();

export default SharedUtil;